import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const DraftModal = ({ isOpen, draftText, onClose, isMobile }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
            onClick={onClose}
          >
            {/* Modal Content */}
            <motion.div
              initial={{ scale: 0.8, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.8, opacity: 0, y: 20 }}
              transition={{ type: "spring", damping: 20, stiffness: 300 }}
              className={`bg-gradient-to-br from-gray-900 to-black border-2 border-cyan-500/50 rounded-xl shadow-[0_0_50px_rgba(6,182,212,0.3)] ${
                isMobile ? 'max-w-sm w-full' : 'max-w-md w-full'
              }`}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Decorative corners */}
              <div className="absolute top-0 left-0 w-4 h-4 border-t-4 border-l-4 border-cyan-400 rounded-tl-lg"></div>
              <div className="absolute top-0 right-0 w-4 h-4 border-t-4 border-r-4 border-cyan-400 rounded-tr-lg"></div>
              <div className="absolute bottom-0 left-0 w-4 h-4 border-b-4 border-l-4 border-cyan-400 rounded-bl-lg"></div>
              <div className="absolute bottom-0 right-0 w-4 h-4 border-b-4 border-r-4 border-cyan-400 rounded-br-lg"></div>

              <div className={`relative ${isMobile ? 'p-6' : 'p-8'}`}>
                {/* Icon */}
                <motion.div
                  initial={{ rotate: -180, scale: 0 }}
                  animate={{ rotate: 0, scale: 1 }}
                  transition={{ delay: 0.2, type: "spring" }}
                  className="text-center mb-6"
                >
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full shadow-lg">
                    <span className="text-3xl">♪</span>
                  </div>
                </motion.div>

                {/* Title */}
                <motion.h3
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 }}
                  className={`text-cyan-400 font-bold uppercase tracking-wider text-center mb-4 ${
                    isMobile ? 'text-sm' : 'text-base'
                  }`}
                >
                  Draft Collected
                </motion.h3>

                {/* Draft Text */}
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.4 }}
                  className={`bg-black/40 border border-cyan-500/30 rounded-lg p-4 mb-6 ${
                    isMobile ? 'min-h-[80px]' : 'min-h-[100px]'
                  }`}
                >
                  <p className={`text-white/90 font-serif italic text-center leading-relaxed ${
                    isMobile ? 'text-sm' : 'text-base'
                  }`}>
                    "{draftText}"
                  </p>
                </motion.div>

                {/* Close Button */}
                <motion.button
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.5 }}
                  onClick={onClose}
                  className={`w-full bg-cyan-500 hover:bg-cyan-400 text-black font-bold uppercase tracking-wider transition-all duration-300 rounded-lg shadow-lg hover:shadow-cyan-500/50 ${
                    isMobile ? 'py-3 text-sm' : 'py-4 text-base'
                  }`}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  Continue
                </motion.button>

                {/* Hint for mobile */}
                {isMobile && (
                  <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.6 }}
                    className="text-center text-gray-500 text-xs mt-3"
                  >
                    Tap anywhere to close
                  </motion.p>
                )}
              </div>
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default DraftModal;